<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="table"
      rowKey="relationId"
      :col="3"
      :columns="getColumns()"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :operationBoxStyle="{ padding: '0 0 16px' }"
      :requestPromise="loadDataList"
    >
      <a-button slot="operation" type="primary" icon="plus" @click="onAddEvent">新建</a-button>
      <template v-slot:ellipsis="{ text }">
        <ellipsis :length="30" tooltip>{{ text }}</ellipsis>
      </template>
      <template v-slot:action="{ record }">
        <a @click="onEditEvent(record)">编辑</a>
      </template>
    </StandardSearchPageView>
    <SimpleFormEditorDialog
      v-if="showDialog"
      :width="520"
      :editConfigList="editConfigList"
      :item="selectItem"
      :rules="rules"
      :title="selectItem && selectItem.relationId ? '编辑关联商品' : '新建关联商品'"
      @cancel="showDialog = false"
      @ok="onEditResultEvent"
    >
      <template v-slot:proId="{ form }">
        <a-button type="primary" @click="onSelectProduct(form)">选择商品</a-button>
        <span v-if="form.proName" style="margin-left: 12px;">{{ form.proName }}</span>
      </template>
      <template v-slot:optionId="{ form }">
        <a-select
          v-model="form.optionId"
          :options="packageOptions"
          placeholder="请选择"
          style="width: 100%"
          allowClear
        />
      </template>
    </SimpleFormEditorDialog>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="productDialog"
      :itemNames="['search_proId', 'search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="getProductListPromise"
      row-key="proId"
      @close="showSelectedDialog = false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID" />
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称" />
      </a-form-item>
      <template slot="proCatalog" slot-scope="rowItem">
        {{ getProCatalogName(rowItem.text, proCatalogEnum) }}
      </template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onProductSelected(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </div>
</template>

<script>
import SimpleFormEditorDialog from '@/customComponents/SimpleFormEditorDialog.vue'
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import productMixins from '@/utils/mixins/productMixins'

export default {
  name: 'AssociatedGoodsComponent',
  mixins: [productMixins],
  components: {
    SimpleFormEditorDialog,
    StandardSearchPageView,
    SelectedProductDialog
  },
  data () {
    return {
      showDialog: false,
      showSelectedDialog: false,
      selectItem: undefined,
      currentForm: undefined,
      queryParams: {},
      packageOptions: [],
      selectedQueryParams: {
        proId: '',
        proName: ''
      },
      searchOptions: [
        {
          name: '预约商品ID',
          key: 'proId',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '山姆商品编号',
          key: 'samsCode',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '商品信息',
          key: 'proName',
          type: 'input',
          placeholder: '请输入'
        },
        {
          name: '更新日期',
          key: 'updateTimeStart,updateTimeEnd',
          type: 'rangePicker'
        }
      ],
      rules: {
        proId: [{ required: true, message: '请选择关联商品', trigger: 'change,blur' }],
        samsCode: [{ required: true, message: '请输入山姆商品编码', trigger: 'change,blur' }]
      },
      editConfigList: [
        {
          name: '关联商品',
          key: 'proId',
          slot: true
        },
        {
          name: '选择套餐/房型',
          key: 'optionId',
          slot: true
        },
        {
          name: '山姆商品编码',
          key: 'samsCode',
          placeholder: '请输入'
        }
      ]
    }
  },
  methods: {
    loadDataList (params) {
      const requestParams = {
        pageNum: params.pageNum || (params.limitDto && params.limitDto.pageNum) || 1,
        pageSize: params.pageSize || (params.limitDto && params.limitDto.pageSize) || 10,
        proId: params.proId || '',
        samsCode: params.samsCode || '',
        proName: params.proName || '',
        updateTimeStart: params.updateTimeStart || '',
        updateTimeEnd: params.updateTimeEnd || ''
      }
      return this.getHttpServices().getSourceService().post('/sams/relation/list', requestParams)
    },
    getColumns () {
      return [
        {
          title: '预约商品ID',
          dataIndex: 'relationProId',
          width: '120px'
        },
        {
          title: '山姆商品编号',
          dataIndex: 'relationSamsCode',
          width: 220,
          scopedSlots: { customRender: 'ellipsis' }
        },
        {
          title: '商品信息',
          dataIndex: 'relationProName',
          width: 280,
          scopedSlots: { customRender: 'ellipsis' }
        },
        {
          title: '关联套餐/房型',
          dataIndex: 'relationOptionName',
          width: '140px'
        },
        {
          title: '商品分类',
          dataIndex: 'relationCategory',
          width: '100px'
        },
        {
          title: '更新时间',
          dataIndex: 'relationUpdateTime',
          width: '180px',
          customRender: (text) => {
            return text ? this.getDateHelper().formatDate(text, 'YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '80px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    onAddEvent () {
      this.packageOptions = []
      this.selectItem = {
        relationId: undefined,
        proId: undefined,
        proName: undefined,
        optionId: undefined,
        samsCode: undefined
      }
      this.showDialog = true
    },
    async onEditEvent (item) {
      // let proName   
      // if (item.relationProId) {  //无论有没有都调接口
        let proName = item.relationProName
        if (!proName && item.relationProId) {
        try {
          const res = await this.getProductListPromise({
            proId: item.relationProId,
            limitDto: { pageNum: 1, pageSize: 1 }
          })
          proName = res && res.data && res.data[0] ? res.data[0].proName : undefined
        } catch (reason) {
          this.showNetWorkErrorMessage(reason)
        }
      }
      this.selectItem = {
        relationId: item.relationId,
        proId: item.relationProId,
        proName,
        optionId: item.relationOptionId || undefined,
        samsCode: item.relationSamsCode
      }
      this.showDialog = true
      if (item.relationProId) {
        this.getPackageOptionList(item.relationProId)
      } else {
        this.packageOptions = []
      }
    },
    onSelectProduct (form) {
      this.currentForm = form
      this.showSelectedDialog = true
    },
    getProductListPromise (params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    onProductSelected (record) {
      if (!this.currentForm || !record) {
        return
      }
      this.currentForm.proId = record.proId
      this.currentForm.proName = record.proName
      this.currentForm.optionId = undefined
      this.showSelectedDialog = false
      this.getPackageOptionList(record.proId)
    },
    getPackageOptionList (proId) {
      if (!proId) {
        this.packageOptions = []
        return
      }
      const params = {
        limitDto: { pageNum: 1, pageSize: 1000 },
        proId
      }
      this.getHttpServices().getProService().post('api/v2/productManage/findOptionList', params).then(res => {
        const list = res && res.data && res.data.length > 0 ? res.data : []
        this.packageOptions = list.map(item => ({
          label: item.optionName || '',
          value: item.optionId
        }))
      }).catch(reason => {
        this.packageOptions = []
        this.showNetWorkErrorMessage(reason)
      })
    },
    onEditResultEvent (form) {
      const isEdit = !!form.relationId
      const params = {
        samsCode: form.samsCode,
        proId: form.proId,
        optionId: form.optionId
      }
      if (isEdit) {
        params.relationId = form.relationId
      }
      const url = isEdit ? '/sams/relation/update' : '/sams/relation/create'
      this.getHttpServices().getSourceService().post(url, params).then(() => {
        this.$message.success(isEdit ? '编辑成功' : '新建成功')
        this.showDialog = false
        this.$refs.table.refresh(true)
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    }
  }
}
</script>

<style scoped></style>
